import React from "react"

const Availability = props => (
  <div className="Availability">
    Availability: <strong className={props.level}>{props.stock}</strong>
  </div>
)

export default Availability